import messages from '../../../locale/messages';
import valid from 'card-validator';

const validate = values => {
  const errors = {
    count: 0,
  };

  if (values.paymentType == 2) {
    if (!values.name) {
      errors.name = messages.required;
      errors.count++;
    }

    if (!values.number) {
      errors.number = messages.required;
      errors.count++;
    } else {
      var numberValidation = valid.number(values.number);
      if (!numberValidation.isValid) {
        errors.number = messages.invalid;
        errors.count++;
      }
    }

    if (!values.month) {
      errors.month = messages.required;
      errors.count++;
    } else {
      var monthValidation = valid.expirationMonth(values.month);
      if (!monthValidation.isValid) {
        errors.month = messages.invalid;
        errors.count++;
      }
    }

    if (!values.year) {
      errors.year = messages.required;
      errors.count++;
    } else {
      var yearValidation = valid.expirationYear(values.year);
      if (!yearValidation.isValid) {
        errors.year = messages.invalid;
        errors.count++;
      }
    }

    if (!values.cvv) {
      errors.cvv = messages.required;
      errors.count++;
    } else {
      var maximumLength = 3;
      var numberValidation = valid.number(values.number);
      if (values.number && numberValidation.isValid) {
        var cardType = valid.number(values.number);
        if (cardType.card.type === 'american-express') {
          maximumLength = 4;
        }
      }
      var cvvValidation = valid.cvv(values.cvv, maximumLength);
      if (!cvvValidation.isValid) {
        errors.cvv = messages.invalid;
        errors.count++;
      }
    }

    if (!values.street) {
      errors.address = 'You must select a billing address';
      errors.count++;
    }
  }

  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/components/Booking/Card/validate.js